/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grand_Brief_Shrike_EmbraceInputs */

const fr_grand_brief_shrike_embrace = /** @type {(inputs: Grand_Brief_Shrike_EmbraceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

/**

* @param {Grand_Brief_Shrike_EmbraceInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const grand_brief_shrike_embrace = /** @type {((inputs?: Grand_Brief_Shrike_EmbraceInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grand_Brief_Shrike_EmbraceInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_grand_brief_shrike_embrace(inputs)
});